module.exports = __webpack_public_path__ + "assets/e15f9f65a80210cac5f96cfed04c9e0a.png";